/**
 * This is a re-implementation of isApolloError from client v3
 */
export function isApolloError(error) {
    return (error !== null &&
        typeof error === 'object' &&
        'graphQLErrors' in error &&
        Array.isArray(error.graphQLErrors));
}
